export const getErfaringsFarge = (erfaringsnivaa: string): string => {
  switch (erfaringsnivaa) {
    case 'avansert': return 'bg-green-100 text-green-800';
    case 'middels': return 'bg-blue-100 text-blue-800';
    case 'grunnleggende': return 'bg-amber-100 text-amber-800';
    default: return 'bg-gray-100 text-gray-800';
  }
};

export const getErfaringsLabel = (erfaringsnivaa: string): string => {
  switch (erfaringsnivaa) {
    case 'avansert': return 'A';
    case 'middels': return 'M';
    case 'grunnleggende': return 'G';
    default: return '?';
  }
};

